module.exports = __webpack_public_path__ + "img/整体定制橱柜.520c480d.webp";